import { getRoute } from '@/router//utils/routeNames';
import { STEP } from '@/router/steps';
import type { StepConfig } from '@/router/types';

const stepConfig: StepConfig = {
  path: 'abschluss',
  routeName: 'completion',
  meta: {
    showStepper: false,
  },

  beforeEnter: (_to, from, next) => {
    // redirect if previous route is unknown
    if (from.name === null || from.name === undefined) {
      next({ name: getRoute(STEP.INPUT) });
      return;
    }

    next();
  },
};

export default stepConfig;
